import Menu from './Menu';
import MenuEntry from './MenuEntry';
import MenuIcon from './MenuIcon';
import MenuTitle from './MenuTitle';

export default Object.assign(Menu, { Entry: MenuEntry, Title: MenuTitle, Icon: MenuIcon });
